/**
 * SPDX-FileCopyrightText: © 2014 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: LGPL-3.0-or-later
 */

import debounce from './debounce';

import './link';

import './plugins';

import './selection-region';

import './table';

import './tools';

import './uicore';

export {debounce};
